import commonService from "./common-service";

class RefillService {
  async deleteEntry(id) {
    try {
      const response = await commonService.deleteToServer("Scheduler?id=" + id);
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async createEntry(params) {
    try {
      const response = await commonService.postToServer("Scheduler", params);
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async updateEntry(id, params) {
    try {
      const response = await commonService.updateToServer("Scheduler?id="+id, params);
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getEntries() {
    try {
      const response = await commonService.getFromServer("Scheduler", {});
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error("Error loading carriers");
    }
  }
}
export default new RefillService();
